import { dispatch } from '../events/dispatcher.js';
import { db } from '../db/db.js';
import {
  DEFAULT_USER_SETTINGS,
  type UserSettings,
} from '../db/schema.js';

/**
 * UserSettings 走 event log（v0.4，為 sync 鋪路）。
 *
 * 任何 settings 改動都先 dispatch `settings_updated`，projector 會 merge patch
 * 並 put 回 db.settings（singleton row）。直接 db.settings.put 視為過渡相容，
 * 不被視為 source of truth — rebuildProjections 走 event log 重建時會被覆蓋。
 *
 * patch 是「淺合併」即可：UserSettings 沒巢狀物件，全部都是 primitive 或 array。
 * Array 欄位（knownLocations）整個取代，呼叫端負責準備好新 array。
 *
 * 顯式 `undefined` 視為「清除欄位」（用於 activeShoppingSource 等 optional 欄位）。
 */
export type SettingsPatch = Partial<{
  [K in keyof Omit<UserSettings, 'id'>]: UserSettings[K] | undefined;
}>;

export async function updateSettings(patch: SettingsPatch): Promise<UserSettings> {
  await dispatch('settings_updated', { patch: patch as Record<string, unknown> });
  // dispatcher 同 transaction 內已執行 projector，當前 row 已是最新
  const next = await db.settings.get('singleton');
  return next ?? DEFAULT_USER_SETTINGS;
}
